import { render } from "./dialog-lock.vue?vue&type=template&id=51dedef6&scoped=true"
import script from "./dialog-lock.vue?vue&type=script&lang=js"
export * from "./dialog-lock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51dedef6"]])

export default __exports__